import { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { ConfigContext } from '../../components/Common/ConfigHelper';
import { GlobalContext } from '../../contexts/GlobalContext';
import { getDeviceType } from '../Common/CommonHooks';
import account_opening_logo from '../../info/Include/images/account_opening_logo.png';
import app_3in1_logo from '../../info/Include/images/app.png';
import raoStep1 from '../../info/Include/images/otp_update_mobile_rao_step1.svg';
import raoStep2 from '../../info/Include/images/otp_update_mobile_rao_step2.svg';
import raoStep1ch from '../../info/Include/images/otp_update_mobile_rao_step1_ch.svg';
import raoStep2ch from '../../info/Include/images/otp_update_mobile_rao_step2_ch.svg';
import step1 from '../../info/Include/images/otp_update_mobile_step1.png';
import step2 from '../../info/Include/images/otp_update_mobile_step2.png';
import step3 from '../../info/Include/images/otp_update_mobile_step3.png';
import step1ch from '../../info/Include/images/otp_update_mobile_step1_ch.png';
import step2ch from '../../info/Include/images/otp_update_mobile_step2_ch.png';
import step3ch from '../../info/Include/images/otp_update_mobile_step3_ch.png';
import QRCode from 'react-qr-code';

import { Toast } from '../Common/ui-components';

export const MissingMobile = ({
    showMsg = false,
    onClickNext,
    invalidOTP,
    otp,
    setOtp,
    setIsShowOTPAuth,
    onClickCancelOTP,
    closeBtnEnabled = false,
    getMobile,
    resendOTP,
    isShowOTPToast,
    setIsShowOTPToast,
    setShowLoginLockPopup,
    isMissingMobile,
    shouldCloseOnEsc,
    setIsShowAccountOpeningQRCode,
    onClose=()=>{},
    type
}) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { betslipMenu } = useContext(ConfigContext);
    const globalContext = useContext(GlobalContext);
    const [menuInfo, setMenuInfo] = useState(betslipMenu);
    const numericOnly = (event) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    };
    const resendOtpInterval = window.globalConfig.resendOtpInterval;

    // const [otp, setOtp] = useState('');
    const [resent, setResent] = useState(false);
    const [resendTimer, setResendTimer] = useState(resendOtpInterval);
    const [clearOTP, setClearOTP] = useState(true);
    const [accountOpeningURL, setAccountOpeningURL] = useState('#');
    // const [isShowAccountOpeningQRCode, setIsShowAccountOpeningQRCode] = useState(false);
    const [isShowTroublePopup, setIsShowTroublePopup] = useState(false);
    const [toastApi, toastContent] = Toast.useToast({ max: 1, showTime: 3000, isOTP: true });
    const device = getDeviceType();
    const isMobile = !device.isTablet && !device.isDesktop;
    let mobileStyle = isMobile ? 'is-mobile' : 'is-desktop';
    useEffect(() => {
        if (isMobile) {
            mobileStyle = 'is-mobile';
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobile]);

    useEffect(() => {
        if (device.isTablet) {
            setAccountOpeningURL('#');
        } else if (device.isDesktop) {
            setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_MHKJC'));
        } else {
            setAccountOpeningURL(t('LB_OTP_ACCOUNT_OPENING_SH'));
        }
        // setAccountOpeningURL('#'); // testing
    }, [navigator.platform, navigator.userAgent]);

    useEffect(()=>{
        if (isMissingMobile) {
            document.getElementById("login-password-input").blur()
        }
    },[isMissingMobile])

    const URL_RAO =  `${window.globalConfig.M_URL}/${lang == "ch"?"tc":"en"}/download.html?target=hkjc-account-opening`;
    const URL_3IN1 = `${window.globalConfig.SH_URL}/3in1/${lang}/RAO/RAM`;
    const handleRedirectToApp = () => {
        if(window.globalConfig.MISSING_MOBILE_QRCODE == 'RAO') {
            window.open(URL_RAO); 
        } else if(window.globalConfig.MISSING_MOBILE_QRCODE == '3in1') {
            window.open(URL_3IN1);
        }
    };
    const handleAccountOpeningCancelBtn = () => {
        setIsShowAccountOpeningQRCode && setIsShowAccountOpeningQRCode(false);
        onClickCancelOTP();
    };

    return (
        <>
            {window.globalConfig.MISSING_MOBILE_QRCODE == 'RAO' && (
                <Popup
                    open={isMissingMobile}
                    closeOnDocumentClick={false}
                    shouldCloseOnEsc={false}
                    className={`comingSoonLogOutDialog logout-succ-msg otp-popup ${
                        invalidOTP ? 'otp-invalid' : ''
                    } ${mobileStyle}`}
                >
                    <div className="otp-acopening">
                        {closeBtnEnabled && (
                            <div className="otp-acopening-close" onClick={handleAccountOpeningCancelBtn}>
                                &times;
                            </div>
                        )}
                        <div className="otp-acopening-title">
                            {type=="update" ? t('LB_OTP_ACCOUNT_OPENING_TITLE_UPDATE') : t('LB_OTP_ACCOUNT_MISSING_MOBILE')}
                        </div>
                        <div className={`otp-acopening-message  ${isMobile ? 'mobile' : ''}`}></div>
                        <div className={`otp-acopening-img-group ${isMobile ? 'mobile' : ''}`}>
                            <img src={account_opening_logo} alt="account opening logo" className="otp-acopening-logo" />
                            <div className={`otp-acopening-app-name ${isMobile ? 'mobile' : ''}`}>
                                {t('LB_OTP_ACCOUNT_OPENING_APP_NAME')}
                                {!isMobile && <div className="otp-acopening-app-hints">{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_HINTS')}</div>}
                            </div>

                            {/* <img src={account_opening_qrcode_1} alt="account opening qrcode" className='otp-acopening-qrcode'/> */}
                            {!isMobile && (
                                <div className="otp-acopening-qrcode-div">
                                    <QRCode
                                        value={ URL_RAO }
                                        fgColor="#003C84"
                                    />
                                    <div className="otp-acopening-qrcode-label">
                                        <span>{t(type=='update'?'LB_OTP_ACCOUNT_OPENING_QRCODE_LABEL_UPTATE':'LB_OTP_ACCOUNT_OPENING_QRCODE_LABEL')}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className={`otp-acopening-message  ${isMobile ? 'mobile' : ''}`}>{t(type=='update' ? 'LB_OTP_ACCOUNT_OPENING_MESSAGE_3' : 'LB_OTP_ACCOUNT_MISSING_RAO_MESSAGE')}</div>
                        <div className="otp-acopening-message-container">
                            <div>
                                <div className='otp-acopening-step-image-rao'>
                                    <img
                                        src={lang == 'en' ? raoStep1 : raoStep1ch}
                                        alt="account opening logo"
                                        className="otp-acopening-step-image"
                                    />
                                </div>
                                <div className="otp-acopening-step">
                                    <div className="otp-acopening-step-index">1</div>
                                    <div className='otp-acopening-step-rao'>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_RAO_STEP1')}</div>
                                </div>
                            </div>
                            <div>
                                <div className='otp-acopening-step-image-rao'>
                                    <img
                                        src={lang == 'en' ? raoStep2 : raoStep2ch}
                                        alt="account opening logo"
                                        className="otp-acopening-step-image"
                                    />
                                </div>
                                <div className="otp-acopening-step">
                                    <div className="otp-acopening-step-index">2</div>
                                    <div className='otp-acopening-step-rao'>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_RAO_STEP2')}</div>
                                </div>
                            </div>
                        </div>

                        {!isMobile ? (
                            <div className="otp-acopening-btn-group">
                                <div className="row1">
                                    <div className="cta_blue" onClick={() => handleAccountOpeningCancelBtn()}>
                                        {t('LB_CLOSE')}
                                    </div>
                                </div>
                                {/* <div className='row2'>
                                <div className='cancel-btn' onClick={handleAccountOpeningCancelBtn}>{t('LB_BS_LOGIN_CANCEL')}</div>
                            </div> */}
                            </div>
                        ) : (
                            <div className="otp-acopening-btn-group">
                                <div className="row1">
                                    <div className="cta_yellow" onClick={() => handleRedirectToApp()}>
                                        {t('LB_OPEN_RAO')}
                                    </div>
                                </div>
                                <div className="row2">
                                    <div className="cancel-btn" onClick={() => handleAccountOpeningCancelBtn()}>
                                        {t('LB_BS_LOGIN_CANCEL')}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Popup>
            )}

            {window.globalConfig.MISSING_MOBILE_QRCODE == '3in1' && (
                <Popup
                    open={isMissingMobile}
                    closeOnDocumentClick={false}
                    shouldCloseOnEsc={shouldCloseOnEsc}
                    onClose={onClose}
                    className={`comingSoonLogOutDialog logout-succ-msg otp-acopening ${
                        invalidOTP ? 'otp-invalid' : ''
                    } ${mobileStyle}`}
                >
                    <div className="otp-acopening">
                        {closeBtnEnabled && (
                            <div className="otp-acopening-close" onClick={handleAccountOpeningCancelBtn}>
                                &times;
                            </div>
                        )}
                        <div className="otp-acopening-title" id="missingMobile_title">
                            {type=="update"  ? t('LB_OTP_ACCOUNT_OPENING_TITLE') : t('LB_OTP_ACCOUNT_MISSING_MOBILE_UPDATE')}
                        </div>
                        <div id="otp_acopening_message">
                            <div className={`otp-3in1-message ${isMobile ? 'mobile' : ''}`}  dangerouslySetInnerHTML={{ __html: type=="update"  ? t( isMobile ? 'LB_OTP_ACCOUNT_MISSING_MESSAGE_2_mobile' : 'LB_OTP_ACCOUNT_MISSING_MESSAGE_2') : t(isMobile ? 'LB_OTP_ACCOUNT_MISSING_MESSAGE_1_mobile' : 'LB_OTP_ACCOUNT_MISSING_MESSAGE_1') }}>
                            </div>
                        </div>
                        <div className="otp-acopening-wrap">
                            <div className="otp-3in1-img-group">
                                <div className="otp-acopening-app" id="otp_acopening_app_name">
                                    <img
                                        src={app_3in1_logo}
                                        alt="account opening logo"
                                        className="otp-acopening-logo"
                                    />
                                    <div className={`otp-3in1-app-name ${isMobile ? 'mobile' : ''}`}>{t('LB_OPT_ACCOUNT_3IN1')}</div>
                                </div>
                                {/* <img src={account_opening_qrcode_1} alt="account opening qrcode" className='otp-acopening-qrcode'/> */}
                                {!isMobile && (
                                    <div className="otp-3in1-qrcode-div" id="otp_3in1_qrcode">
                                        <QRCode value={URL_3IN1} fgColor="#003C84" />
                                        <div className="otp-acopening-qrcode-label">
                                            <span>{t('LB_OTP_3IN1_QRCODE_QRCODE_LABEL')}</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {isMobile && (
                                <div>
                                    <div className="account-opening-below" id="otp_acopening_step">
                                        <span>{t('LB_OTP_ACCOUNT_OPENING_MESSAGE_2')}</span>
                                    </div>
                                    <div className="flex-box">
                                        <div className="mobile-step" id="otp_acopening_more">
                                            <div class="mobile-step-3in1">
                                                <img
                                                    src={lang == 'en' ? step1 : step1ch}
                                                    alt="account opening logo"
                                                    className="otp-acopening-step-image threein1"
                                                />
                                            </div>
                                            <div className="otp-acopening-step1">
                                                <div className="otp-acopening-step-index">1</div>
                                                <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_3IN1_STEP1')}</div>
                                            </div>
                                        </div>
                                        <div className="mobile-step" id="otp_acopening_help">
                                            <div class="mobile-step-3in1">
                                                <img
                                                    src={lang == 'en' ? step2 : step2ch}
                                                    alt="account opening logo"
                                                    className="otp-acopening-step-image threein1"
                                                />
                                            </div>
                                            <div className="otp-acopening-step2">
                                                <div className="otp-acopening-step-index">2</div>
                                                <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_3IN1_STEP2')}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mobile-step-full" id="otp_acopening_add">
                                        <div class="mobile-step-3in1">
                                            <img
                                                src={lang == 'en' ? step3 : step3ch}
                                                alt="account opening logo"
                                                className="otp-acopening-step-image threein1"
                                            />
                                        </div>
                                        <div className="otp-acopening-step3">
                                            <div className="otp-acopening-step-index">3</div>
                                            <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_3IN1_STEP3')}</div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!isMobile && (
                                <div className="otp-acopening-message-wrap">
                                    {
                                        <div id="otp_acopening_step">
                                            <span>{t('LB_OTP_ACCOUNT_OPENING_MESSAGE_2')}</span>
                                        </div>
                                    }
                                    <div className="otp-3in1-message-container">
                                        <div id="otp_acopening_more">
                                            <div className='otp-3in1-message-img'>
                                                <img
                                                    src={lang == 'en' ? step1 : step1ch}
                                                    alt="account opening logo"
                                                    className="otp-3in1-step-image"
                                                />
                                            </div>
                                            <div className="otp-acopening-step1">
                                                <div className="otp-acopening-step-index">1</div>
                                                <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_3IN1_STEP1')}</div>
                                            </div>
                                        </div>
                                        <div id="otp_acopening_help">
                                            <div className='otp-3in1-message-img'>
                                                <img
                                                    src={lang == 'en' ? step2 : step2ch}
                                                    alt="account opening logo"
                                                    className="otp-3in1-step-image"
                                                />
                                            </div>
                                            <div className="otp-acopening-step2">
                                                <div className="otp-acopening-step-index">2</div>
                                                <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_3IN1_STEP2')}</div>
                                            </div>
                                        </div>
                                        <div id="otp_acopening_add">
                                            <div className='otp-3in1-message-img'>
                                                <img
                                                    src={lang == 'en' ? step3 : step3ch}
                                                    alt="account opening logo"
                                                    className="otp-3in1-step-image"
                                                />
                                            </div>
                                            <div className="otp-acopening-step3">
                                                <div className="otp-acopening-step-index">3</div>
                                                <div>{t('LB_OTP_ACCOUNT_UPDATE_MOBILE_3IN1_STEP3')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {!isMobile ? (
                            <div className="otp-acopening-btn-group">
                                <div className="row1">
                                    <div
                                        className="cta_blue"
                                        id="otp_acopening_close"
                                        onClick={() => handleAccountOpeningCancelBtn()}
                                    >
                                        {t('LB_CLOSE')}
                                    </div>
                                </div>
                                {/* <div className='row2'>
                                <div className='cancel-btn' onClick={handleAccountOpeningCancelBtn}>{t('LB_BS_LOGIN_CANCEL')}</div>
                            </div> */}
                            </div>
                        ) : (
                            <div className="otp-acopening-btn-group">
                                <div className="row1">
                                    <div
                                        className="cta_yellow"
                                        id="otp_acopening_open"
                                        onClick={() => handleRedirectToApp()}
                                    >
                                        {t('LB_OPEN')}
                                    </div>
                                </div>
                                <div className="row2">
                                    <div
                                        className="cancel-btn"
                                        id="otp_acopening_close"
                                        onClick={() => handleAccountOpeningCancelBtn()}
                                    >
                                        {t('LB_BS_LOGIN_CANCEL')}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Popup>
            )}
        </>
    );
};
